function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  ).filter((element) => {
    if (element.closest('[aria-hidden="true"]')) return false;
    const style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return Boolean(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
  });
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.currentTarget.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    const min = this.input.min ? parseInt(this.input.min) : null;
    const max = this.input.max ? parseInt(this.input.max) : null;
    const buttonMinus = this.querySelector(".quantity__button[name='minus']");
    const buttonPlus = this.querySelector(".quantity__button[name='plus']");
    const locked = this.classList.contains('rlx-quantity-disabled') || this.input.disabled;
    const setButtonState = (button, disabled) => {
      if (!button) return;
      button.classList.toggle('disabled', disabled);
      button.disabled = disabled;
      button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    };

    setButtonState(buttonMinus, locked || (min !== null && value <= min));
    setButtonState(buttonPlus, locked || (max !== null && value >= max));
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)').matches) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.querySelector('#menu-drawer')?.addEventListener('click', this.onMenuLinkClick.bind(this));
  }

  onMenuLinkClick(event) {
    if (event.defaultPrevented) return;

    const link = event.target?.closest?.('a[href]');
    if (!link || !this.mainDetailsToggle.hasAttribute('open')) return;

    const summary = this.mainDetailsToggle.querySelector('summary');
    if (!summary) return;

    this.closeMenuDrawer(event, summary);
    summary.setAttribute('aria-expanded', false);
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      /* IMP-D1（R2c-008）: media listenerは匿名にせずhandlerを保存し、
         disconnectedCallbackで解除・再接続時に1回だけ再登録する。 */
      this.rlxReducedMotionHandler = () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      };
      this.reducedMotion.addEventListener('change', this.rlxReducedMotionHandler);
      this.rlxReducedMotionBound = true;

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  connectedCallback() {
    /* IMP-D1（R2c-008）: 再接続時はhandler実在かつ未登録の場合だけ1回再登録する。 */
    if (this.reducedMotion && this.rlxReducedMotionHandler && !this.rlxReducedMotionBound) {
      this.reducedMotion.addEventListener('change', this.rlxReducedMotionHandler);
      this.rlxReducedMotionBound = true;
    }
  }

  disconnectedCallback() {
    /* IMP-D1（R2c-008）: 切断時にmedia listenerを解除する（増殖・浮遊参照の防止）。 */
    if (this.reducedMotion && this.rlxReducedMotionHandler && this.rlxReducedMotionBound) {
      this.reducedMotion.removeEventListener('change', this.rlxReducedMotionHandler);
      this.rlxReducedMotionBound = false;
    }
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    /* IMP-D1（D1-01）: reduced-motion変更のたびに新しいbindでlistenerが増殖しないよう、
       登録は1回だけ行う（handlerを保存し、2回目以降のsetAutoPlayは状態更新のみ）。 */
    if (!this.rlxAutoplayListenersBound) {
      this.rlxAutoplayListenersBound = true;
      this.rlxFocusInHandler = this.focusInHandling.bind(this);
      this.rlxFocusOutHandler = this.focusOutHandling.bind(this);
      this.addEventListener('mouseover', this.rlxFocusInHandler);
      this.addEventListener('mouseleave', this.rlxFocusOutHandler);
      this.addEventListener('focusin', this.rlxFocusInHandler);
      this.addEventListener('focusout', this.rlxFocusOutHandler);
    }

    if (this.querySelector('.slideshow__autoplay')) {
      if (!this.sliderAutoplayButton) {
        this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
        this.rlxAutoplayToggleHandler = this.autoPlayToggle.bind(this);
        this.sliderAutoplayButton.addEventListener('click', this.rlxAutoplayToggleHandler);
      }
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    /*
      RELAXIM 追加（第19回検品）: currentVariantの有無を判定するより前に、
      対象product-formへvariant切替開始を必ず通知する。不存在の組み合わせで
      hidden商品IDのvalueが変化しないケースでも、この呼び出しだけは必ず発火させる。
      保留中のcart/add応答が、この切替より前の選択に対する古い応答だと
      product-form側で判定できるようにする。
    */
    const rlxSection = this.closest('section');
    const rlxProductForm = rlxSection ? rlxSection.querySelector('product-form') : null;
    if (rlxProductForm && typeof rlxProductForm.rlxNotifyVariantSelectionChanging === 'function') {
      rlxProductForm.rlxNotifyVariantSelectionChanging();
    }

    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    /*
      切替開始から最新の商品HTMLが確定するまでは、旧バリエーションの入荷案内を
      表示しない。無効な組み合わせ・通信失敗でも古いCTAが残らないよう安全側へ倒す。
    */
    const restockLead = document.getElementById(`RlxRestockLead-${this.dataset.section}`);
    if (restockLead) restockLead.hidden = true;
    const cartLimitLead = document.getElementById(`RlxCartLimitLead-${this.dataset.section}`);
    if (cartLimitLead) cartLimitLead.hidden = true;
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (!input) return;
      input.value = this.currentVariant.id;
      const productFormHost =
        typeof productForm.closest === 'function' ? productForm.closest('product-form') : null;
      const cartAddBusy = !!(
        productFormHost &&
        (typeof productFormHost.rlxIsCartAddBusy === 'function'
          ? productFormHost.rlxIsCartAddBusy()
          : productFormHost.rlxCartAddBusy === true)
      );
      if (
        productFormHost &&
        typeof productFormHost.rlxForgetVariantServerPurchaseState === 'function'
      ) {
        productFormHost.rlxForgetVariantServerPurchaseState(this.currentVariant.id);
      }
      /*
        初期表示が売り切れの場合、Liquidは商品IDのhidden inputもdisabledにする。
        販売可能な別variantへ切り替えた時は値だけでなくdisabledも解除しないと、
        購入ボタンが有効でもFormDataへ商品IDが入らない。売り切れ方向も双方向同期する。
        数量上限は応答HTMLを受けるproduct-info.js側が再度fail-closedで無効化する。
      */
      if (this.currentVariant.available && !cartAddBusy) {
        input.removeAttribute('disabled');
      } else {
        input.setAttribute('disabled', 'disabled');
      }
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    /*
      RELAXIM 追加（第17回検品）: 呼出開始時にthis.currentVariantが存在しない、
      または.idがnull/undefinedの場合、直後の requestedVariantId = this.currentVariant.id
      で同期例外になる。要求世代の更新・fetch・DOMParser・DOM更新・購入ボタン更新・
      publishのいずれも行わず即returnする。要求開始後・応答到着前にnullへ変わる
      ケースは第16回の応答適用前ガード（requestGeneration一致・currentVariant存在・
      ID一致）で既に安全なため、ここでは呼出開始時のnullだけを対象にする。
    */
    if (!this.currentVariant || this.currentVariant.id === null || this.currentVariant.id === undefined) {
      return;
    }
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    /*
      RELAXIM: updateVariantInput()直後の現在IDへ、過去に記録したunknown／soldout理由を
      直ちに復元する。商品HTMLのfetchが失敗しても、Aへ戻った時の固定警告・
      カート確認導線・売り切れ表示を失わない。
    */
    const currentVariantForm = document.getElementById(`product-form-${this.dataset.section}`);
    const currentProductFormHost =
      currentVariantForm && typeof currentVariantForm.closest === 'function'
        ? currentVariantForm.closest('product-form')
        : null;
    if (
      currentProductFormHost &&
      typeof currentProductFormHost.rlxApplyCurrentSubmissionState === 'function'
    ) {
      currentProductFormHost.rlxApplyCurrentSubmissionState();
    } else if (
      currentProductFormHost &&
      typeof currentProductFormHost.rlxApplyCurrentSubmissionLock === 'function'
    ) {
      currentProductFormHost.rlxApplyCurrentSubmissionLock();
    }
    /*
      RELAXIM 追加（第16回検品 不合格2）: 要求開始ごとに単調増加する世代番号を
      インスタンス単位で採番する。requestedVariantIdの一致だけでは、A要求を
      保留中にA→B→Aと選び直した場合、最終A応答より最初のA応答が後から届くと
      IDが再び一致してしまい古い応答が正規応答を巻き戻す。世代番号を併用し、
      応答適用時に最新世代であることも必須条件にする。
    */
    const requestGeneration = (this.rlxProductInfoRequestGeneration =
      (this.rlxProductInfoRequestGeneration || 0) + 1);

    /*
      RELAXIM 追加（第18回検品 不合格1）: 呼出元・検査側が完了と失敗を追跡できるよう、
      fetch chainのPromiseをそのままreturnする。
    */
    return fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => {
        /*
          RELAXIM 追加（第18回検品 不合格2）: response.okがfalseの場合、本文を
          正常な商品HTMLとして解析・反映・publishしないよう、response.text()を
          呼ばずにErrorをthrowする。HTTP status以外（本文・URL・秘密情報）は
          Errorへ含めない。
        */
        if (!response.ok) {
          throw new Error(`RELAXIM: renderProductInfoのHTTP応答が異常です (status ${response.status})`);
        }
        return response.text();
      })
      .then((responseText) => {
        /*
          RELAXIM 追加（第16回検品 不合格2）: DOMParser・価格/SKU/在庫/数量価格/
          単価/購入ボタン更新・publishなど、全てのUI副作用より前に次を確認する。
          1. 要求時に採番した世代が、まだ最新世代であること（A→B→Aの後着A破棄）。
          2. currentVariantが存在すること（null例外にしない）。
          3. 現在のvariant IDが要求時のvariant IDと一致すること（既存の
             abandoned selection防止を維持、String()で正規化して比較）。
          いずれか不成立ならDOMParserも呼ばずreturnし、DOM・publishに触れない。
        */
        if (requestGeneration !== this.rlxProductInfoRequestGeneration) return;
        if (!this.currentVariant) return;
        if (String(this.currentVariant.id) !== String(requestedVariantId)) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('hidden', !inventorySource || inventorySource.innerText === '');

        /*
          RELAXIM: variant.availableだけでは、最低必要数量が実在庫を上回る購入不可を
          判定できない。要求世代とvariant IDのstale応答ガードを通過した最新HTMLの
          product formを正本にし、購入ボタンを更新する前にhidden商品IDのdisabledを
          双方向同期する。source欠落・ID不一致・server側disabled・結果不明ロック・
          destination欠落は全てfail-closedとし、その結果を通常購入ボタンと高速購入にも
          合成する。値の上書きやchangeイベントの再送出は行わない。
        */
        const variantFormSource = html.getElementById(`product-form-${sectionId}`);
        const variantInputSource = variantFormSource
          ? variantFormSource.querySelector('input[name="id"]')
          : null;
        const variantFormDestination = document.getElementById(`product-form-${this.dataset.section}`);
        const variantInputDestination = variantFormDestination
          ? variantFormDestination.querySelector('input[name="id"]')
          : null;
        const productFormHost =
          variantFormDestination && typeof variantFormDestination.closest === 'function'
            ? variantFormDestination.closest('product-form')
            : null;
        let variantBaseHiddenBlocked = true;
        let submissionLocked = false;
        let cartAddBusy = false;
        let variantSubmissionBlocked = true;
        if (variantInputDestination) {
          submissionLocked = !!(
            productFormHost &&
            (typeof productFormHost.rlxIsSubmissionLockedForVariant === 'function'
              ? productFormHost.rlxIsSubmissionLockedForVariant(requestedVariantId)
              : productFormHost.submissionLocked === true)
          );
          cartAddBusy = !!(
            productFormHost &&
            (typeof productFormHost.rlxIsCartAddBusy === 'function'
              ? productFormHost.rlxIsCartAddBusy()
              : productFormHost.rlxCartAddBusy === true)
          );
          const sourceVariantIdMatchesRequested =
            !!variantInputSource &&
            variantInputSource.value !== null &&
            variantInputSource.value !== undefined &&
            String(variantInputSource.value) === String(requestedVariantId);
          variantBaseHiddenBlocked =
            !variantInputSource ||
            !sourceVariantIdMatchesRequested ||
            variantInputSource.hasAttribute('disabled');
          variantSubmissionBlocked = variantBaseHiddenBlocked || submissionLocked || cartAddBusy;
          if (variantSubmissionBlocked) {
            variantInputDestination.setAttribute('disabled', 'disabled');
          } else {
            variantInputDestination.removeAttribute('disabled');
          }
        }

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        const addButtonUpdatedLabel = addButtonUpdated ? addButtonUpdated.querySelector('span') : null;
        const addButtonUpdatedText = addButtonUpdatedLabel ? addButtonUpdatedLabel.textContent.trim() : '';
        const responseButtonDisabled = !addButtonUpdated || addButtonUpdated.hasAttribute('disabled');
        if (
          productFormHost &&
          typeof productFormHost.rlxRememberVariantServerPurchaseState === 'function'
        ) {
          productFormHost.rlxRememberVariantServerPurchaseState(
            requestedVariantId,
            !variantBaseHiddenBlocked && !responseButtonDisabled
          );
        }
        const responseUnavailableText =
          addButtonUpdatedText ||
          (window.variantStrings && window.variantStrings.soldOut ? window.variantStrings.soldOut : '売り切れ');
        const failClosedUnavailableText =
          window.variantStrings && window.variantStrings.unavailable
            ? window.variantStrings.unavailable
            : '現在購入できません';
        const unavailableText =
          variantSubmissionBlocked && !responseButtonDisabled
            ? failClosedUnavailableText
            : responseUnavailableText;
        this.toggleAddButton(responseButtonDisabled || variantSubmissionBlocked, unavailableText);
        /*
          RELAXIM: source buttonの一般文言を反映した後、variant別の停止理由を最終適用する。
          unknownは固定警告＋カート確認、soldoutは売り切れラベルへ戻す。
        */
        if (productFormHost && typeof productFormHost.rlxApplyCurrentSubmissionState === 'function') {
          productFormHost.rlxApplyCurrentSubmissionState();
        } else if (
          productFormHost &&
          typeof productFormHost.rlxApplyCurrentSubmissionLock === 'function'
        ) {
          productFormHost.rlxApplyCurrentSubmissionLock();
        }

        /*
          RELAXIM 購入上限案内: variant応答の常設要素からhiddenだけを双方向同期する。
          切替先で上限に達していればカート確認導線を出し、販売可能へ戻れば消す。
          source欠落時は古い案内を残さず安全側で隠す。
        */
        const cartLimitLeadSource = html.getElementById(`RlxCartLimitLead-${sectionId}`);
        const cartLimitLeadDestination = document.getElementById(`RlxCartLimitLead-${this.dataset.section}`);
        if (cartLimitLeadDestination) {
          cartLimitLeadDestination.hidden = !cartLimitLeadSource || cartLimitLeadSource.hidden;
        }

        /*
          RELAXIM 入荷案内: バリエーション切替後の描画HTMLから売り切れ専用CTAの
          hidden状態を同期する。数量上限による購入不可はvariant自体が販売可能なため
          source側がhiddenとなり、入荷案内を誤表示しない。source欠落時は安全側で隠す。
        */
        const restockLeadSource = html.getElementById(`RlxRestockLead-${sectionId}`);
        const restockLeadDestination = document.getElementById(`RlxRestockLead-${this.dataset.section}`);
        if (restockLeadDestination) {
          restockLeadDestination.hidden = !restockLeadSource || restockLeadSource.hidden;
        }

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      })
      .catch(() => {
        /*
          RELAXIM 追加（第18回検品 不合格1・不合格2）: fetch/response.text/HTTP非OKの
          throwはここで受け止め、未処理Promise拒否にしない。
          古い要求（既に新しい要求が発行済み）の失敗はUI・ログへ一切影響させず無言で
          returnする。最新要求の失敗だけ、固定の日本語メッセージをconsole.errorへ
          1回だけ渡す（Errorオブジェクト・本文・URL・秘密情報は渡さない）。
          いずれの場合もcatch自身はthrowし直さず、返却Promiseを解決状態で終える
          （onVariantChange()が先にfail-closedへ倒した購入ボタン状態はそのまま維持され、
          DOMParser・DOM更新・購入ボタン更新・publish・世代番号への追加変更は行わない）。
        */
        if (requestGeneration !== this.rlxProductInfoRequestGeneration) return;
        console.error('商品情報の更新に失敗しました。');
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton || !addButtonText) return;

    /*
      RELAXIM: cart/addの結果不明・売切確定lockはvariant ID単位で保持する。
      現在のhidden商品IDがlocked Setに含まれる時だけ実効disableへ合成し、
      別variantの購入ボタン・高速購入へ恒久lockを波及させない。
    */
    const productFormElement = productForm.closest('product-form');
    const currentVariantInput = productForm.querySelector('input[name="id"]');
    const currentVariantId = currentVariantInput ? currentVariantInput.value : null;
    const submissionLocked = !!(
      productFormElement &&
      (typeof productFormElement.rlxIsSubmissionLockedForVariant === 'function'
        ? productFormElement.rlxIsSubmissionLockedForVariant(currentVariantId)
        : productFormElement.submissionLocked === true)
    );
    const cartAddBusy = !!(
      productFormElement &&
      (typeof productFormElement.rlxIsCartAddBusy === 'function'
        ? productFormElement.rlxIsCartAddBusy()
        : productFormElement.rlxCartAddBusy === true)
    );
    const effectiveDisable = disable || submissionLocked || cartAddBusy;

    if (effectiveDisable) {
      addButton.setAttribute('disabled', 'disabled');
      if (disable && text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.removeAttribute('aria-disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    /*
      RELAXIM: variant切替中・売り切れ・無効組合せ・通信失敗のいずれでも、
      通常購入ボタンのdisabled状態と高速購入（payment_button）ラッパーの
      表示状態を必ず同期する。要素が無い（初期売り切れで動的生成しない等）
      場合は何もしない。
    */
    const dynamicCheckoutWrapper = productForm.querySelector('[data-rlx-dynamic-checkout]');
    if (dynamicCheckoutWrapper) {
      dynamicCheckoutWrapper.hidden = effectiveDisable;
      dynamicCheckoutWrapper.setAttribute('aria-hidden', effectiveDisable);
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    if (!button) return;
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    if (!addButton || !addButtonText) return;
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    /* IMP-D3（D7-01/D7-02・D2-01）: 世代・HTTPステータス・接続状態のguardと、切断時のobserver/fetch解除。
       再接続後に古い応答が新しい内容を巻き戻す事故と、非2xx HTMLの流し込みを防ぐ。 */
    this.rlxGeneration = (this.rlxGeneration || 0) + 1;
    const generation = this.rlxGeneration;
    /* AbortControllerが無い環境（検査VM・旧ブラウザ）では世代guardだけで運用する */
    this.rlxAbortController = typeof AbortController !== 'undefined' ? new AbortController() : null;

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url, this.rlxAbortController ? { signal: this.rlxAbortController.signal } : {})
        .then((response) => {
          if (!response.ok) {
            console.error(`おすすめ商品の取得に失敗しました。(HTTP ${response.status})`);
            return null;
          }
          return response.text();
        })
        .then((text) => {
          if (text === null) return;
          if (!this.isConnected || generation !== this.rlxGeneration) return;
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          if (e && e.name === 'AbortError') return;
          console.error('おすすめ商品の取得に失敗しました。');
        });
    };

    this.rlxIntersectionObserver = new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    });
    this.rlxIntersectionObserver.observe(this);
  }

  disconnectedCallback() {
    /* IMP-D3: 切断時に監視とfetchを解除（世代も進め、遅延応答の適用を構造的に遮断） */
    this.rlxGeneration = (this.rlxGeneration || 0) + 1;
    if (this.rlxIntersectionObserver) this.rlxIntersectionObserver.disconnect();
    if (this.rlxAbortController) this.rlxAbortController.abort();
  }
}

customElements.define('product-recommendations', ProductRecommendations);
